/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useMemo} from 'react';
import {AccountLink} from '@ion/core/src/types/entities';
import useMedia from '../../hooks/useMedia';
import {getGlobalProp} from '../../props/GlobalPropsConfig';
import GroupChooserAccordion, {
  AutoSelectClient
} from './GroupChooserAccordion';
import GroupChooserNestedMenu from './GroupChooserNestedMenu';

interface selectedSearchValueType {
  title: string;
  href: string;
}

interface GroupsHierarchyDisplayProps extends AutoSelectClient {
  groups: AccountLink[];
  radioValue: any;
  setRadioValue: Function;
  selectedSearchValue: selectedSearchValueType;
  crumbValue: any;
  expansionList: any[];
  mainListLength: number;
};

/**
 * Component to display Global Groups Search Results
 * ```typescript
 * import GroupsHierarchyDisplay from '@ion/dls/src/components/groupchooser/GroupsHierarchyDisplay';
 *
 * <GroupsHierarchyDisplay groups={groups}
 *   radioValue={radioValue}
 *   setRadioValue={setRadioValue}
 *   selectedSearchValue={selectedSearchValue}
 *   crumbValue={crumbValue}
 *   expansionList={expansionList}
 *   mainListLength={mainListLength}/>
 * ```
 */
const GroupsHierarchyDisplay = ({
  groups,
  radioValue,
  setRadioValue,
  selectedSearchValue,
  crumbValue,
  expansionList,
  mainListLength,
  disableAutoSelect = false
}: GroupsHierarchyDisplayProps) => {
  const {isPhone, isDesktop}  = useMedia();
  const useDrillDownHierarchy = useMemo(() => (
    isDesktop && getGlobalProp('GlobalGroupChooser.desktop.useDrillDownHierarchy', false) as boolean
  ), [isDesktop]);

  return (
    <>
      {groups.map((group, i) => {
        return (
          <div key={`root-global-group-option-${i}`} style={{height: 'inherit'}}>
            {
              (isPhone || useDrillDownHierarchy) ? (
                <GroupChooserNestedMenu group={group}
                  radioValue={radioValue}
                  selectedSearchValue={selectedSearchValue} />
              ) : (
                <GroupChooserAccordion isRootAccount
                  group={group}
                  radioValue={radioValue}
                  setRadioValue={setRadioValue}
                  crumbValue={crumbValue}
                  openExpansionId={group.href}
                  expansionList={expansionList}
                  selectedSearchValue={selectedSearchValue}
                  mainListLength={mainListLength}
                  disableAutoSelect={disableAutoSelect} />
              )
            }
          </div>
        );
      })}
    </>
  );
};

export default GroupsHierarchyDisplay;
